type Target = (...args: any[]) => void;

const callAll = (...fns: Array<Target | undefined>) => (...args: any[]) =>
  fns.forEach(fn => fn && fn(...args));

export default callAll;